import { onMounted, ref } from 'vue';
import { useI18n, useTutorialApi, useUrl } from '@/composables';
import { getAffiliateNetworksCountApiRequest } from '@/services/api/affiliate-networks-api';
import { getTrafficSourcesCountApiRequest } from '@/services/api/traffic-sources-api';
import { getCampaignsCountApiRequest } from '@/services/api/campaign-api';
import { getOffersCountApiRequest } from '@/services/api/offers-api';
import { getLandingsCountApiRequest } from '@/services/api/landings-api';
import { useStore } from '@/store';

export const useQuickstart = () => {
  const store = useStore();
  const { t } = useI18n();
  const { getLink } = useUrl();
  const affiliateNetworkCount = ref(0);
  const trafficSourceCount = ref(0);
  const campaignCount = ref(0);
  const offerCount = ref(0);
  const landingCount = ref(0);

  const tutorial = useTutorialApi(getLink);

  const quickStart = () => {
    store.toggleTutorialQuickStart();
  };

  onMounted(() => {
    getAffiliateNetworksCountApiRequest({}).then((response) => {
      affiliateNetworkCount.value = response.count;
    });

    getTrafficSourcesCountApiRequest({}).then((response) => {
      trafficSourceCount.value = response.count;
    });

    getCampaignsCountApiRequest({}).then((response) => {
      campaignCount.value = response.count;
    });

    getOffersCountApiRequest({}).then((response) => {
      offerCount.value = response.count;
    });

    getLandingsCountApiRequest({}).then((response) => {
      landingCount.value = response.count;
    });
  });

  return {
    t,
    tutorial,
    affiliateNetworkCount,
    trafficSourceCount,
    campaignCount,
    offerCount,
    landingCount,
    quickStart,
  };
};
